const NotFound = () => {
    return <div className="webpage">
        <div className="pageSurface p-4">
            <h1 className="text-light">Page not found</h1>
        </div>
    </div>
}

export default NotFound;